module.exports = __webpack_public_path__ + "static/img/order-coupon-bottom1.39c978a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/order-coupon-bottom1.png
// module id = 339
// module chunks = 7